import fetch from 'auth/FetchInterceptor';
import instance from './axios/index';
import { API_BASE_URL } from '../configs/AppConfig';
import axios from 'axios';
const AuthService = {};

AuthService.login = async (payload) => {
    const {username, password, captchaValue} = payload;
    try {
        let endpoint = 'auth/signin';
        let data = {
            username: username,
            password: password,
            captchaValue: captchaValue ?? ''
        };
        const response = await axios.post(`${API_BASE_URL}${endpoint}`, data
            // , {
            //     withCredentials: true // <== Get refreshToken by httpOnly Cookie!
            // }
        );

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.logout = async () => {
    try {
        let endpoint = 'auth/signout';
        await instance.post(`${API_BASE_URL}${endpoint}`);
        return;
    } catch (error) {
        return error;
    }
};
AuthService.verify = async () => {
    try {
        let endpoint = 'auth/verify';
        const response = await instance.get(`${API_BASE_URL}${endpoint}`);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.info = async () => {
    try {
        let endpoint = 'auth/info';
        const response = await instance.get(`${API_BASE_URL}${endpoint}`);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.update = async (data) => {
    try {
        let endpoint = 'auth/update';
        const response = await instance.post(`${API_BASE_URL}${endpoint}`, data);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.change_password = async (data) => {
    try {
        let endpoint = 'auth/change_password';
        const response = await instance.post(`${API_BASE_URL}${endpoint}`, data);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.register = function (data) {
    return fetch({
        url: '/auth/register',
        method: 'post',
        data: data,
    });
};
AuthService.token = async (data) => {
    console.log(data)
    try {
        let endpoint = 'auth/token';
        const response = await instance.post(`${API_BASE_URL}${endpoint}`, data);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
AuthService.generate = async () => {
    try {
        let endpoint = 'auth/generate';
        const response = await instance.post(`${API_BASE_URL}${endpoint}`);

        if (response.status === 200) {
            return Promise.resolve(response.data);
        }
    } catch (error) {
        return error;
    }
};
export default AuthService;
